/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-undef */
import React, { useEffect, useState } from "react";
import MainHeader from "./MainHeader";
import WeeklySchedule from "./WeeklySchedule";
import { useTranslation } from "react-i18next";
import { QuestionOutlined } from '@ant-design/icons';
import confirmModal from '../../core/components/modals/ConfirmModal';
import { useAuthStateValue } from "../../context/AuthContext";
import {
  Container,
  StyledDivLogout,
  StyledReactSVG,
  LogoutButton,
  UserWrapper,
  Name,
  Email,
  MainFooterDashboard,
  OuterContainer,
  DeleteAccountLink,
} from "./Dashboard.style";
import logoutIcon from "../../assets/images/icons/sign-out-alt-solid.svg";
import { Modal } from "antd";

const Dashboard = () => {
  const { loggedUser, logout, deleteAccount } = useAuthStateValue();
  const { t } = useTranslation();
  const [isNotificationsOnly, setIsNotificationsOnly] = useState(false);

  useEffect(() => {
    const extendUser = loggedUser?.extendUser;
    if (extendUser?.workplace === "Korisnik") {
      setIsNotificationsOnly(true);
    }
  }, [loggedUser]);

  const onLogoutModal = () => {
    confirmModal({
      centered: true,
      icon: <QuestionOutlined />,
      title: t("modal.logoutTitle"),
      content: t("modal.logoutMessage"),
      okText: t('buttons.yes'),
      cancelText: t('buttons.no'),
      onOk: async () => {
        logout();
      }
    })
  }

  const onDeleteAccount = () => {
    Modal.confirm({
      centered: true,
      icon: <QuestionOutlined />,
      title: t("modal.deleteAccountTitle"),
      content: t("modal.deleteAccountMessage"),
      okText: t('buttons.yes'),
      cancelText: t('buttons.no'),
      okType: 'danger',
      onOk: async () => {
        await deleteAccount();
        await logout();
      }
    });
  }

  const name = loggedUser?.firstName + " " + loggedUser?.lastName;
  const email = loggedUser?.username;

  return (
    <OuterContainer>
      <div>

      <WeeklySchedule />
      <MainHeader></MainHeader>
      </div>
      <MainFooterDashboard style={{backgroundColor: '#e6e6e6'}}>
        <UserWrapper>
          <Name>{name}</Name>
          <Email>{email}</Email>
        </UserWrapper>
        <LogoutButton onClick={onLogoutModal}>
          <StyledDivLogout>
            <StyledReactSVG src={logoutIcon}></StyledReactSVG>
            {t("buttons.logout")}
          </StyledDivLogout>
        </LogoutButton>
         {isNotificationsOnly && (
           <DeleteAccountLink onClick={onDeleteAccount} tabIndex={0} role="button">
             {t('dashboard.deleteAccount')}
           </DeleteAccountLink>
         )}
      </MainFooterDashboard>
    </OuterContainer>
  );
};

export default Dashboard;
